// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Badge, { badgeClasses } from '@mui/material/Badge';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgBlur } from 'src/theme/css';
// routes
import { paths } from 'src/routes/paths';
// components
import Logo from 'src/components/logo';
//
import { HEADER } from '../config-layout';
import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
//
import { HeaderShadow, LoginButton, LanguagePopover, SettingsButton } from '../_common';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useDispatch } from 'react-redux';
import { clear } from 'src/store/slices/userSlice';
import { useBoolean } from 'src/hooks/use-boolean';
import { useRouter } from 'src/routes/hooks';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { Button } from '@mui/material';

// ----------------------------------------------------------------------

export default function Header() {
  const theme = useTheme();

  const { t } = useLocales()

  const mdUp = useResponsive('up', 'md');

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  const { user } = useMockedUser();

  const openPartner = useBoolean();

  const dispatch = useDispatch();

  const router = useRouter();

  const handleBecomePartnerClick = (e) => {
    e.preventDefault();
    console.log("user", user)

    if (user?.userType === 'user') {
      openPartner.onTrue();
    } else {
      router.push('/auth/register', { state: { state: 'organizer' } });
    }
  };


  const handleConfirmBecomePartner = () => {
    // Clear Redux state
    dispatch(clear()); // your redux clear/reset action

    // Clear storage
    localStorage.removeItem("persist:root");
    // Close modal
    openPartner.onFalse()

    // Navigate to partner register page
    router.push('/auth/register', {
      replace: true,
      state: { state: 'organizer' },
    });
  };

  const navConfig = [
    // {
    //   title: t("home.home"),
    //   icon: <Iconify icon="solar:home-2-bold-duotone" />,
    //   path: '/#how-it-works',
    // },

    {
      title: t("home.become_a_partner"),
      icon: <Iconify icon="carbon:partnership" />,
      // path: '/#how-it-works',
      // path: '/auth/register',
      state: { state: 'organizer' },
      onClick: handleBecomePartnerClick
    },

    {
      title: t("home.active_giveaway"),
      icon: <Iconify icon="solar:gift-bold-duotone" />,
      path: "/#active-giveaway",
    },
  ];

  return (
    <AppBar>
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.05)',
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          <Badge
            sx={{
              [`& .${badgeClasses.badge}`]: {
                top: 8,
                right: -16,
              },
            }}
            badgeContent={
              <Link
                href={paths.changelog}
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{ ml: 1 }}
              >
                {/* <Label color="info" sx={{ textTransform: 'unset', height: 22, px: 0.5 }}>
                  v5.5.0
                </Label> */}
              </Link>
            }
          >
            <Logo home={true} />
          </Badge>

          <Box sx={{ flexGrow: 1 }} />

          {mdUp && <NavDesktop offsetTop={offsetTop} data={navConfig} />}

          <Stack alignItems="center" direction={{ xs: 'row', md: 'row-reverse' }}>
            {/* <Button variant="contained" target="_blank" rel="noopener" href={paths.minimalUI}>
              Purchase Now
            </Button> */}

            <Box sx={{ marginLeft: 2 }}>
              <LanguagePopover />
            </Box>
            <SettingsButton />
            {mdUp && <LoginButton />}

            {/* <SettingsButton
              sx={{
                ml: { xs: 1, md: 0 },
                mr: { md: 2 },
              }}
            /> */}

            {!mdUp && <NavMobile offsetTop={offsetTop} data={navConfig} />}

          </Stack>
        </Container>
      </Toolbar>

      <ConfirmDialog maxWidth="xs"
        title={t("home.become_a_partner")}
        content={t("home.become_a_partner_content")}
        open={openPartner.value}
        onClose={openPartner.onFalse}
        action={
          <Button variant="contained" onClick={handleConfirmBecomePartner} color="error" >
            {t("home.confirm")}</Button>
        }
      />

      {offsetTop && <HeaderShadow />}
    </AppBar >
  );
}
